import {
  styled,
  Box,
  Dialog,
  DialogContent,
  IconButton,
  dialogClasses,
} from '@mui/material';

export const DialogIntegrationsInfoContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    // maxWidth: 1000,
    width: '100%',
    minHeight: 'calc(100% - 64px)',
  },
});

export const DialogIntegrationsInfoHeader = styled(Box)(({ theme }) => ({
  flex: 'none',
  padding: theme.spacing(2, 3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const DialogIntegrationsInfoHeaderCloseIcon = styled(IconButton)(
  ({ theme }) => ({
    color: theme.palette.grey[500],
  }),
);

export const DialogIntegrationsInfoContent = styled(DialogContent)({
  display: 'flex',
  flexDirection: 'column',
});
